import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, MessageCircle, Home, Heart, Baby, Activity, ChevronDown, ChevronUp } from 'lucide-react';
const chapters = [{
  id: 1,
  icon: Activity,
  color: 'text-[#B83A52]',
  bg: 'bg-[#FDF0F3]',
  title: 'El Choque Inicial',
  subtitle: 'Cómo gestionar las primeras 72 horas',
  content: 'Pasar del pánico al plan en menos de 24 horas. Incluye la Técnica de los Círculos de Confianza para comunicar la noticia sin crear caos.'
}, {
  id: 2,
  icon: Users,
  color: 'text-[#1B3A6B]',
  bg: 'bg-[#EEF2F7]',
  title: 'El Sistema Operativo Familiar',
  subtitle: 'Roles claros sin conflictos',
  content: 'Cómo dividir tareas sin peleas y sin que todo caiga sobre una sola persona. Los 3 roles críticos que toda familia necesita cubrir.'
}, {
  id: 3,
  icon: MessageCircle,
  color: 'text-[#1B3A6B]',
  bg: 'bg-[#EEF2F7]',
  title: 'El Arte de Acompañar',
  subtitle: 'Qué decir y qué callar',
  content: 'Las frases exactas que reconfortan de verdad — y las que, sin saberlo, duelen más que el silencio. Aprende a estar presente.'
}, {
  id: 4,
  icon: Home,
  color: 'text-[#4A4A6A]',
  bg: 'bg-[#F3F4F6]',
  title: 'El Hogar como Santuario',
  subtitle: 'Ambiente de paz, no de hospital',
  content: 'Cómo transformar el espacio para que tu familiar descanse mejor, se sienta más cómodo y más amado, no solo "paciente".'
}, {
  id: 5,
  icon: Heart,
  color: 'text-[#B83A52]',
  bg: 'bg-[#FDF0F3]',
  title: 'El Cuidador Primero',
  subtitle: 'Tu guía de supervivencia emocional',
  content: 'La Regla de los 20 Minutos. El Inventario de Energía. El protocolo anti-culpa. Sostenerte tú para poder sostener a quien amas.'
}, {
  id: 6,
  icon: Baby,
  color: 'text-[#1B3A6B]',
  bg: 'bg-[#EEF2F7]',
  title: 'Niños y Adolescentes',
  subtitle: 'Cómo incluirlos sin asustarlos',
  content: 'Cómo hablar con los más pequeños. Qué decirles. Cómo protegerlos sin mentirles para que se sientan seguros.'
}, {
  id: 7,
  icon: BookOpen,
  color: 'text-[#4A4A6A]',
  bg: 'bg-[#F3F4F6]',
  title: 'Cuando el Camino se Pone Difícil',
  subtitle: 'Recaídas y momentos duros',
  content: 'Herramientas para los momentos de incertidumbre, cuidados paliativos y duelo anticipado. Saber estar cuando no hay palabras.'
}];
export function WeeklyBreakdown() {
  const [expanded, setExpanded] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-[#FDFAF7] border-t border-[#E2E8F0]" data-id="element-357">
      <div className="max-w-[800px] mx-auto" data-id="element-358">
        <div className="text-center mb-12" data-id="element-359">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B83A52] mb-2" data-id="element-360">
            Índice de Contenidos
          </p>
          <h2 className="text-3xl font-serif font-bold text-[#1C1C2E] mb-4" data-id="element-361">
            Lo Que Encontrarás Dentro
          </h2>
          <p className="text-[#4A4A6A] max-w-xl mx-auto" data-id="element-362">
            7 Capítulos diseñados para responder a la pregunta: "¿Qué hago
            ahora?" en cada etapa del proceso.
          </p>
        </div>

        <div className="space-y-3" data-id="element-363">
          {chapters.map((c, i) => <motion.div key={c.id} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden" data-id="element-364">
              <button className="w-full text-left p-4 flex items-center gap-4 hover:bg-[#FAFAFA] transition-colors" onClick={() => setExpanded(expanded === c.id ? null : c.id)} data-id="element-365">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${c.bg}`} data-id="element-366">
                  <c.icon className={`w-5 h-5 ${c.color}`} data-id="element-367" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-368">
                  <h3 className="font-bold text-[#1C1C2E] text-base leading-tight" data-id="element-369">
                    Capítulo {c.id}: {c.title}
                  </h3>
                  <p className="text-xs text-[#4A4A6A] mt-1 font-medium" data-id="element-370">
                    {c.subtitle}
                  </p>
                </div>
                <div className="shrink-0" data-id="element-371">
                  {expanded === c.id ? <ChevronUp className="w-5 h-5 text-[#8B8BAA]" data-id="element-372" /> : <ChevronDown className="w-5 h-5 text-[#8B8BAA]" data-id="element-373" />}
                </div>
              </button>

              {expanded === c.id && <div className="px-4 pb-4 pl-[72px] pr-8" data-id="element-374">
                  <p className="text-[#4A4A6A] text-sm leading-relaxed border-l-2 border-[#E2E8F0] pl-4" data-id="element-375">
                    {c.content}
                  </p>
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}